import { clientePedido } from '../../apiClient/index'

const moduloClientes = {
    namespaced: true,
    
    state: {
        filtrosClientes: {
            razonSocial: undefined,
            cuenta: undefined,
            id: undefined
        }
    },
    actions: {
        getClientes(){
            return new Promise((resolve, reject) => {
                clientePedido.get('api/clientes/GetListaClientes')
                             .then(response => {
                                resolve(response.data)
                             })
                             .catch(error => {
                                reject(error.response.data)
                             })
            })
        },
        getCuentasCorrientes(_, IdCliente){
            return new Promise((resolve, reject) => {
                clientePedido.get(`api/clientes/GetCuentasCorrientes?IdCliente=${IdCliente}`)
                             .then(response => {
                                resolve(response.data)
                             })
                             .catch(error => {
                                reject(error.response.data)
                             })
            })
        },
        getCuentasPendientes(_, payload) {
            return new Promise((resolve, reject) => {
                clientePedido.get('/api/clientes/GetPendientes', {params: payload})
                             .then(response => {
                                resolve(response.data)
                             })
                             .catch(error => {
                                reject(error.response.data)
                             })
            })
        },
        exportarExcelPendientes(_, payload) {
            return new Promise((resolve, reject) => {
                clientePedido.post('/api/clientes/ExportExcelPendientes', payload)
                             .then(response => {
                                resolve(response.data)
                             })
                             .catch(error => {
                                reject(error.response.data)
                             })
            })
        },
        getDocumentos(context, payload) {
            return new Promise((resolve, reject) => {
              clientePedido
                .get("api/clientes/GetResumen", { params: payload })
                .then((response) => resolve(response.data))
                .catch(() => reject());
            });
          },
          getCuentas(context, idUsuario) {
            return new Promise((resolve, reject) => {
              clientePedido
                .get("api/clientes/GetCuentasCorrientes", {
                  params: { idUsuario: idUsuario },
                })
                .then((response) => resolve(response.data))
                .catch(() => reject());
            });
          },
          getCancelaciones(context, payload) {
            return new Promise((resolve, reject) => {
              clientePedido
                .get("api/clientes/GetCancelacionesDocumentos", { params: payload })
                .then((response) => resolve(response.data))
                .catch(() => reject());
            });
          },
          getRecibo(context, payload) {
            return new Promise((resolve, reject) => {
              clientePedido
                .get("api/clientes/GetRecibo", {
                  params: { idRecibo: payload.idRecibo },
                })
                .then((response) => {
                  resolve(response.data.Datos);
                })
                .catch(() => reject());
            });
          },
          descargarFactura(context, payload) {
            return new Promise((resolve, reject) => {
              clientePedido
                .get("api/clientes/DescargarFactura", {
                  params: payload,
                  responseType: "arraybuffer",
                })
                .then((response) => {
                  resolve(response);
                })
                .catch(() => {
                  reject();
                });
            });
          },
          exportarExcel(_, payload) {
            return new Promise((resolve, reject) => {
              clientePedido
                .get("/api/clientes/ExportExcelResumen", { params: payload })
                .then((response) => {
                  resolve(response.data);
                })
                .catch((error) => {
                  reject(error.response.data);
                });
            });
          },
    },
    mutations: {
        setFiltrosClientes(state, payload) {
          state.filtrosClientes = payload;
        },
      },
   
}

export default moduloClientes